export default __webpack_public_path__ + "static/media/Chat-App.0b582339.png";